import {
  Component, Injector, Input
} from '@angular/core';
import { ANDROID_APP_LINK, IMAGES_URL } from '@src/app/core/constants/system-list.constant';
import { CoreClass } from '@src/app/core/base/core.class';
@Component({
  selector: 'app-googleplay-btn',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false,
})
export class GoogleplayBtnComponent extends CoreClass {
  constructor(injector: Injector) {
    super(injector)
  }
  @Input() heading: string = '';
  IMAGES_URL: string = IMAGES_URL;

  ANDROID_APP: string = ANDROID_APP_LINK
}
